export default function ($translate) {
    return {
        KEYS: {
            ADMIN: 'ADMIN',
            PORTAL: 'PORTAL'
        },
        LABELS: {
            ADMIN: $translate.instant('userNps.Admin'),
            PORTAL: $translate.instant('userNps.Portal')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/nps/originType/index.js